var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532227,
    y: 1.05637,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#FF6161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6902 13.904C16.535 13.904 16.4092 14.0298 16.4092 14.1851V19.4965C16.4092 19.6516 16.535 19.7775 16.6902 19.7775C16.8454 19.7775 16.9712 19.6516 16.9712 19.4965V14.1851C16.9712 14.0298 16.8454 13.904 16.6902 13.904Z",
    fill: "#FF6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3748 13.904C13.2196 13.904 13.0938 14.0298 13.0938 14.1851V19.4965C13.0938 19.6516 13.2196 19.7775 13.3748 19.7775C13.53 19.7775 13.6558 19.6516 13.6558 19.4965V14.1851C13.6558 14.0298 13.53 13.904 13.3748 13.904Z",
    fill: "#FF6161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9573 13.1289V20.0528C10.9573 20.4621 11.1074 20.8464 11.3696 21.1222C11.6305 21.3987 11.9936 21.5557 12.3737 21.5564H17.6909C18.071 21.5557 18.4342 21.3987 18.695 21.1222C18.9571 20.8464 19.1072 20.4621 19.1072 20.0528V13.1289C19.6283 12.9906 19.966 12.4871 19.8963 11.9524C19.8265 11.4178 19.371 11.0179 18.8318 11.0177H17.3929V10.6665C17.3946 10.3711 17.2778 10.0874 17.0686 9.8787C16.8595 9.67012 16.5754 9.55398 16.28 9.5564H13.7846C13.4891 9.55398 13.205 9.67012 12.9959 9.8787C12.7868 10.0874 12.67 10.3711 12.6716 10.6665V11.0177H11.2328C10.6936 11.0179 10.2381 11.4178 10.1683 11.9524C10.0986 12.4871 10.4362 12.9906 10.9573 13.1289ZM17.6909 20.9943H12.3737C11.8932 20.9943 11.5194 20.5815 11.5194 20.0528V13.1536H18.5451V20.0528C18.5451 20.5815 18.1714 20.9943 17.6909 20.9943ZM13.2337 10.6665C13.2318 10.5201 13.2893 10.3793 13.3932 10.276C13.4969 10.1727 13.6381 10.1159 13.7846 10.1185H16.28C16.4264 10.1159 16.5676 10.1727 16.6714 10.276C16.7752 10.3792 16.8327 10.5201 16.8309 10.6665V11.0177H13.2337V10.6665ZM11.2328 11.5798H18.8318C19.1112 11.5798 19.3376 11.8063 19.3376 12.0857C19.3376 12.365 19.1112 12.5915 18.8318 12.5915H11.2328C10.9534 12.5915 10.7269 12.365 10.7269 12.0857C10.7269 11.8063 10.9534 11.5798 11.2328 11.5798Z",
    fill: "#FF6161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.032 13.904C14.8768 13.904 14.751 14.0298 14.751 14.1851V19.4965C14.751 19.6516 14.8768 19.7775 15.032 19.7775C15.1872 19.7775 15.313 19.6516 15.313 19.4965V14.1851C15.313 14.0298 15.1872 13.904 15.032 13.904Z",
    fill: "#FF6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconCart);
export default __webpack_public_path__ + "static/media/deleteIconCart.0b8dcdde68cc83d50ae59fc63ab212b3.svg";
export { ForwardRef as ReactComponent };